import { render } from "./App.vue?vue&type=template&id=ee3d0db6&bindings={\"reload\":\"setup\",\"isError\":\"setup\",\"isRetrieved\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render

export default script